import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

function Grafik() {
  const [istatistikler, setIstatistikler] = useState([]);
  const [filters, setFilters] = useState({ baslangic: '', bitis: '' });
  const [selectedBirim, setSelectedBirim] = useState(null);
  const [birimPersoneller, setBirimPersoneller] = useState([]);
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();

  useEffect(() => {
    fetchIstatistikler();
  }, []);

  const fetchIstatistikler = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.baslangic) params.append('baslangic', filters.baslangic);
      if (filters.bitis) params.append('bitis', filters.bitis);

      const response = await api.get(`/ziyaretciler/istatistik/birim?${params.toString()}`);
      setIstatistikler(response.data);
    } catch (error) {
      alert('Hata: ' + (error.response?.data?.error || 'İstatistikler yüklenemedi'));
    } finally {
      setLoading(false);
    }
  };

  const handleBirimClick = async (birim) => {
    setSelectedBirim(birim);
    try {
      const response = await api.get(`/personeller/birim/${birim.id}`);
      setBirimPersoneller(response.data);
    } catch (error) {
      console.error('Personeller yüklenemedi:', error);
    }
  };

  const handleQuickFilter = (type) => {
    const today = new Date();
    let baslangic, bitis;

    switch(type) {
      case 'bugun':
        baslangic = new Date(today.setHours(0, 0, 0, 0)).toISOString();
        bitis = new Date(today.setHours(23, 59, 59, 999)).toISOString();
        break;
      case 'hafta':
        const weekStart = new Date(today);
        weekStart.setDate(today.getDate() - today.getDay() + 1);
        baslangic = new Date(weekStart.setHours(0, 0, 0, 0)).toISOString();
        bitis = new Date().toISOString();
        break;
      case 'ay':
        baslangic = new Date(today.getFullYear(), today.getMonth(), 1).toISOString();
        bitis = new Date().toISOString();
        break;
      case 'yil':
        baslangic = new Date(today.getFullYear(), 0, 1).toISOString();
        bitis = new Date().toISOString();
        break;
      default:
        baslangic = '';
        bitis = '';
    }

    setFilters({ baslangic, bitis });
  };

  useEffect(() => {
    fetchIstatistikler();
  }, [filters]);

  const maxZiyaret = Math.max(...istatistikler.map(i => parseInt(i.ziyaret_sayisi)), 1);

  return (
    <div className="container">
      <div className="nav">
        <button onClick={() => navigate('/admin/dashboard')} className="btn btn-secondary">
          ← Geri
        </button>
        <button onClick={() => navigate('/admin/rapor')} className="btn btn-secondary">
          Raporlar
        </button>
      </div>

      <div className="card">
        <h2 style={{ color: '#ff0000' }}>Birim Bazlı İstatistikler</h2>

        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '10px' }}>Zaman Aralığı</h3>
          <button onClick={() => handleQuickFilter('bugun')} className="btn btn-secondary">
            Bugün
          </button>
          <button onClick={() => handleQuickFilter('hafta')} className="btn btn-secondary">
            Bu Hafta
          </button>
          <button onClick={() => handleQuickFilter('ay')} className="btn btn-secondary">
            Bu Ay
          </button>
          <button onClick={() => handleQuickFilter('yil')} className="btn btn-secondary">
            Bu Yıl
          </button>
          <button onClick={() => handleQuickFilter('')} className="btn btn-secondary">
            Tüm Zamanlar
          </button>
        </div>

        {loading ? (
          <div className="loading">Yükleniyor...</div>
        ) : (
          <>
            <div style={{ marginTop: '30px' }}>
              <h3 style={{ color: '#ff0000', marginBottom: '20px' }}>
                Ziyaret Sayıları (Grafiksel Gösterim)
              </h3>
              
              {istatistikler.map((stat, index) => {
                const percentage = (parseInt(stat.ziyaret_sayisi) / maxZiyaret) * 100;
                
                return (
                  <div 
                    key={stat.id}
                    style={{ 
                      marginBottom: '20px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => handleBirimClick(stat)}
                  >
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between',
                      marginBottom: '5px',
                      fontWeight: 'bold'
                    }}>
                      <span>{stat.birim_adi}</span>
                      <span style={{ color: '#ff0000' }}>{stat.ziyaret_sayisi} ziyaret</span>
                    </div>
                    
                    <div style={{
                      width: '100%',
                      height: '40px',
                      backgroundColor: '#333',
                      borderRadius: '5px',
                      overflow: 'hidden',
                      position: 'relative',
                      border: '2px solid #ff0000'
                    }}>
                      <div style={{
                        width: `${percentage}%`,
                        height: '100%',
                        backgroundColor: '#ff0000',
                        transition: 'width 1s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontWeight: 'bold',
                        animation: 'pulse 2s infinite'
                      }}>
                        {percentage > 15 && `${Math.round(percentage)}%`}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {selectedBirim && (
              <div style={{ 
                marginTop: '40px',
                padding: '20px',
                backgroundColor: '#ffe6e6',
                borderRadius: '10px',
                border: '2px solid #ff0000'
              }}>
                <h3 style={{ color: '#ff0000', marginBottom: '15px' }}>
                  📊 {selectedBirim.birim_adi} - Personel Detayları
                </h3>
                
                <button 
                  onClick={() => setSelectedBirim(null)}
                  className="btn btn-secondary"
                  style={{ marginBottom: '15px' }}
                >
                  ✖ Kapat
                </button>

                {birimPersoneller.length === 0 ? (
                  <p>Bu birimde kayıtlı personel bulunmuyor.</p>
                ) : (
                  <div className="table-container">
                    <table>
                      <thead>
                        <tr>
                          <th>Personel</th>
                          <th>Görevi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {birimPersoneller.map(p => (
                          <tr key={p.id}>
                            <td>{p.ad_soyad}</td>
                            <td>{p.gorev || '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            <div style={{ marginTop: '40px' }}>
              <h3 style={{ color: '#ff0000', marginBottom: '20px' }}>
                📈 Özet İstatistikler
              </h3>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '20px'
              }}>
                <div style={{
                  padding: '20px',
                  backgroundColor: '#ffe6e6',
                  borderRadius: '10px',
                  border: '2px solid #ff0000',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '32px', color: '#ff0000', fontWeight: 'bold' }}>
                    {istatistikler.reduce((sum, s) => sum + parseInt(s.ziyaret_sayisi), 0)}
                  </div>
                  <div style={{ marginTop: '10px', fontWeight: 'bold' }}>Toplam Ziyaret</div>
                </div>

                <div style={{
                  padding: '20px',
                  backgroundColor: '#ffe6e6',
                  borderRadius: '10px',
                  border: '2px solid #ff0000',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '32px', color: '#ff0000', fontWeight: 'bold' }}>
                    {istatistikler.length}
                  </div>
                  <div style={{ marginTop: '10px', fontWeight: 'bold' }}>Aktif Birim</div>
                </div>

                <div style={{
                  padding: '20px',
                  backgroundColor: '#ffe6e6',
                  borderRadius: '10px',
                  border: '2px solid #ff0000',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '32px', color: '#ff0000', fontWeight: 'bold' }}>
                    {istatistikler.length > 0 ? 
                      Math.round(istatistikler.reduce((sum, s) => sum + parseInt(s.ziyaret_sayisi), 0) / istatistikler.length)
                      : 0
                    }
                  </div>
                  <div style={{ marginTop: '10px', fontWeight: 'bold' }}>Ortalama/Birim</div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Grafik;
